import React from 'react';
import './Membership.css';

const Membership = () => {
  return (
    <div className="membership-page">
      <div className="container">
        <h1 className="page-title">Membership</h1>
        <p className="page-subtitle">
          Join the European Brief Therapy Association and connect with professionals worldwide 
          who are passionate about solution-focused approaches.
        </p>

        <div className="membership-content">
          <div className="membership-info">
            <h2>Become a member of EBTA!</h2>
            <p className="membership-intro">
              EBTA membership has been updated with the new statutes in July 2013.
            </p>
            <p className="membership-welcome">
              EBTA welcomes you and others who are in good professional standing in their country of origin, 
              who have basic exposure to solution-focused training or the equivalent (minimum 20 hours) and 
              do accept the purpose, goals and rules of EBTA.
            </p>
            <p className="membership-standing">
              'Good professional standings' means that you have a professional training related to helping, 
              teaching or research professions. – This requirement is read broadly.
            </p>
            
            <div className="membership-fee">
              <h3>Annual membership fee: €50,00</h3>
            </div>

            <div className="membership-benefits">
              <h3>With Membership you get:</h3>
              <ul className="benefits-list">
                <li>Collaboration with like-minded professionals being your critical friends</li>
                <li>The possibility to participate in task-groups to enhance solution focused ideas and practices</li>
                <li>Support in spreading solution-focused ideas within EBTA and your network and area</li>
                <li>Influence by voting rights</li>
                <li>Discounts at EBTA Conferences in Europe</li>
              </ul>
            </div>
          </div>

          <div className="membership-form-section">
            <h2>Become a Member</h2>
            <div className="form-container">
              <iframe 
                src="https://ebta.outseta.com/forms/Rm8rwx94"
                width="100%"
                height="800"
                frameBorder="0"
                title="EBTA Membership Form"
                className="membership-form"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Membership;
